import React from "react";

interface Props {
  activeColor: string;
}
const ProfilePictureIcon = (props: Props) => {
  return (
    <div className="elipsee">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7903 15.1813C18.6183 15.1313 18.4432 15.0893 18.2722 15.0493C16.7333 16.013 14.9528 16.521 13.1371 16.5146C11.3213 16.5082 9.54445 15.9877 8.01225 15.0133C6.10321 15.4559 4.39079 16.5095 3.13513 18.0141C1.87948 19.5186 1.1492 21.3919 1.05525 23.3493C1.00525 25.3923 0.963258 27.4353 0.963258 29.4783C0.963258 31.3783 0.82125 31.4353 1.79825 31.6963C1.79825 31.6963 14.3062 34.6133 24.5502 31.7223C24.8059 31.6614 25.031 31.5104 25.1843 31.297C25.3377 31.0836 25.409 30.8221 25.3853 30.5603C25.3393 28.2043 25.4283 25.8473 25.3363 23.4943C25.2784 21.5909 24.6114 19.7562 23.4335 18.2599C22.2557 16.7636 20.6289 15.6846 18.7923 15.1813H18.7903ZM13.2263 14.2973C15.108 14.2688 16.9035 13.5035 18.2271 12.1656C19.5507 10.8278 20.2968 9.02427 20.3053 7.14234C20.3134 6.21043 20.1374 5.28607 19.7874 4.42236C19.4373 3.55865 18.9201 2.7726 18.2654 2.10935C17.6107 1.4461 16.8314 0.918713 15.9723 0.557474C15.1132 0.196234 14.1912 0.00825998 13.2592 0.00434464C12.3158 -0.0060828 11.3795 0.169602 10.504 0.52135C9.62847 0.873097 8.83089 1.39401 8.15688 2.05428C7.48286 2.71455 6.94562 3.50123 6.57591 4.36931C6.2062 5.2374 6.01127 6.16985 6.00226 7.11334C6.02374 9.01891 6.79298 10.8398 8.14424 12.1835C9.4955 13.5273 11.3206 14.2865 13.2263 14.2973Z"
          fill="#9aa3b2"
        />
      </svg>
    </div>
  );
};

export default ProfilePictureIcon;
